import React from 'react'
import { useIntl } from 'react-intl'
import * as R from 'ramda'

const englishLanguage = 'English'

export const LanguageSubscriberCount = ({ name, nativeName, count }) => {
  const { formatMessage } = useIntl()
  const nativeLanguage = name !== englishLanguage ? `(${nativeName})` : ''
  const subscriberCount = R.isNil(count)
    ? null
    : `(${formatMessage(
        {
          id: 'translationPreview.people',
        },
        { subscriberCount: count },
      )})`

  return (
    <div>
      <div className="text-14">
        {nativeName} {subscriberCount}
      </div>
      {name !== englishLanguage && (
        <div className="text-12 font-semibold">{name}</div>
      )}
    </div>
  )
}
